'use client';

import { create } from 'zustand';

import type { Offer } from '@libs/common-types';

export type OfferPageSection = 'homepage' | 'landing page' | 'offers' | 'store events' | 'treats rewards';

type OfferDrawerState = {
    drawerOpen: boolean;
    selectedOffer?: Offer;
    offerPageSection?: OfferPageSection;
};

type OfferDrawerActions = {
    openOffer: (offer: Offer, pageSection?: OfferPageSection) => void;
    closeOffer: () => void;
    markOfferActivated: (offerId: string) => void;
};

type OfferDrawerStore = OfferDrawerState & OfferDrawerActions;

export const initialOfferDrawerState: OfferDrawerState = {
    drawerOpen: false,
    selectedOffer: undefined,
    offerPageSection: undefined,
};

export const useOfferDrawerStore = create<OfferDrawerStore>()(set => ({
    ...initialOfferDrawerState,

    openOffer: (offer, pageSection) =>
        set({
            drawerOpen: true,
            selectedOffer: offer,
            offerPageSection: pageSection,
        }),

    closeOffer: () => set(initialOfferDrawerState),

    markOfferActivated: offerId =>
        set(state => {
            const { selectedOffer } = state;

            if (selectedOffer?.offerId !== offerId) {
                return state;
            }

            return { selectedOffer: { ...selectedOffer, isActivated: true } };
        }),
}));
